import React, { useEffect, useRef, useState } from "react"
import { Button, Modal, Spinner } from "react-bootstrap"

export default function ModalForm(props: any) {
    const { title, show, close, submitFunction } = props
    const [isSubmitting, setIsSubmitting] = useState(false)
    const mountedRef = useRef(true)

    useEffect(() => {
        mountedRef.current = true
        return () => { mountedRef.current = false }
    }, [])

    const handleSubmit = async (e: React.FormEvent) => {
        // Prevent normal form submit and guard against double submits
        e.preventDefault()
        if (isSubmitting) return

        try {
            setIsSubmitting(true)
            // Call the provided submitFunction. It may be sync or return a Promise.
            const result = submitFunction ? submitFunction(e) : null
            if (result && typeof (result as any).then === "function") {
                await result
            }
        } finally {
            // Only update state if component still mounted (modal not closed)
            if (mountedRef.current) setIsSubmitting(false)
        }
    }

    return (
        /* <Modal backdrop="static" keyboard={false} show={show} onHide={close} centered> */
        <Modal size="lg" backdrop="static" keyboard={false} show={show} onHide={close}>
            <Modal.Header>
                <Modal.Title>
                    {title}
                </Modal.Title>
            </Modal.Header>
            <form onSubmit={handleSubmit}>
                <Modal.Body>
                    {props.children}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={close} disabled={isSubmitting}>
                        Cancelar
                    </Button>
                    <Button type="submit" variant="primary" disabled={isSubmitting} aria-busy={isSubmitting}>
                        {isSubmitting ? (
                            <>
                                <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />
                                {' '}
                                Guardando...
                            </>
                        ) : 'Guardar'}
                    </Button>
                </Modal.Footer>
            </form>
        </Modal>
    )
}